module.exports = __webpack_public_path__ + "fonts/HMpangram-SemiBold.59d75e22.ttf";